var exports = {
  "pz": "sidebar__uzUvS_",
  "_C": "bodyScrollable__thIdr2",
  "U0": "condensed__5nQkem",
  "zE": "expandedSmall__b0TNj8",
  "HU": "expandedMedium__EfTa0e",
  "Ho": "expandedLarge__iLfTBV",
  "Ig": "resizable__zzxMkG",
  "vv": "toggleList__NGtu3v",
  "qr": "footer__K2REC_",
  "Xt": "footerStructural__MpGmUH",
  "$7": "sentinel__svRsg6",
  "Qx": "footerClipping__uQlsJP",
};

module.exports = exports;
